const footerLinks = {
  '影视导航': ['国产剧', '韩剧', '美剧', '日剧', '电影', '综艺', '动漫', '纪录片'],
  '热门推荐': ['星辰大海', '暗夜追光', '山海传说', '欢乐喜剧人', '极限挑战'],
  '关于我们': ['平台介绍', '常见问题', '联系方式', '最新动态'],
};

const partners = [
  '合作伙伴一', '合作伙伴二', '合作伙伴三', '合作伙伴四', '合作伙伴五', '合作伙伴六',
];

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-foreground-300">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <h3 className="text-lg font-heading font-bold text-white mb-4">天狼影院</h3>
            <p className="text-sm leading-relaxed text-foreground-400">
              天狼影院提供高清免费在线观看，即点即播不缓冲，流畅追剧看电影，涵盖最新电视剧、电影、综艺大全连播，海量高清视频资源。
            </p>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h3 className="text-sm font-semibold text-white mb-4">{title}</h3>
              <ul className="space-y-2">
                {links.map((link) => (
                  <li key={link}>
                    <a
                      href="#"
                      className="text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-foreground-700/30 pt-8 mb-8">
          <h3 className="text-sm font-semibold text-white mb-4">合作伙伴</h3>
          <div className="flex flex-wrap gap-4">
            {partners.map((partner) => (
              <span
                key={partner}
                className="px-4 py-2 bg-foreground-800/30 rounded text-xs text-foreground-400"
              >
                {partner}
              </span>
            ))}
          </div>
        </div>

        <div className="border-t border-foreground-700/30 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; 2020-2026 天狼影院 版权所有 | 仅供学习交流，不存储任何视频内容
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-400 hover:text-white transition-colors cursor-pointer">
              用户协议
            </a>
            <a href="#" className="text-xs text-foreground-400 hover:text-white transition-colors cursor-pointer">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-400 hover:text-white transition-colors cursor-pointer">
              免责声明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}